import AgentActivity from 'models/agent_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import DtoConverter from 'scripts/application/dto_converters/snippet_converter';
import { getAllAttachments } from 'models/answers/snippet_helpers';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_interactive_handler';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import ShowToast from 'actions/toast_deprecated/show_toast';
import Snippet, { SnippetChannels } from 'models/answers/snippet';
import SnippetContent from 'models/answers/snippet_content';
import SnippetEditor from 'models/location/snippet_editor';
import { ToastType } from 'models/toast_deprecated';

export default class SwitchSnippetClone {
  constructor(context) {
    this.context = context;
  }

  run({ cloneId }) {
    this.context.stores.snippetComposition.setLoading();
    changeCurrentLocation(this.context, SnippetEditor.create({ cloneId }));
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.KNOWLEDGE_BASE });

    // Note: we intentionally do NOT set a placeholder snippet in snippetComposition
    // before fetching. This prevents the SnippetGatewayObserver from auto-populating
    // the composition store with the original snippet data. Instead, we process the
    // raw DTO ourselves in onFetchSuccess to create a proper clone.
    return this.context.gateways.snippet
      .fetch({ snippetId: cloneId })
      .then(snippetDto => this.onFetchSuccess(snippetDto))
      .catch(errDto => this.onFetchError(errDto));
  }

  onFetchSuccess(snippetDto) {
    const original = DtoConverter.fromDto(snippetDto);

    const clonedContents = original.contents.map(channels => {
      return SnippetChannels.create({
        language: channels.language,
        anyChannel: this.cloneContentWithoutAttachments(channels.anyChannel),
        info: this.cloneContentWithoutAttachments(channels.info),
        message: this.cloneContentWithoutAttachments(channels.message),
        selfService: this.cloneContentWithoutAttachments(channels.selfService),
      });
    });

    const clonedSnippet = Snippet.create({
      name: original.name ? `${original.name} (copy)` : '',
      description: original.description || '',
      audienceIds: original.audienceIds ? [...original.audienceIds] : [],
      contents: clonedContents,
    });

    this.context.stores.snippetComposition.set(clonedSnippet);
    this.context.stores.snippetComposition.clearErrors();
    this.context.stores.snippetComposition.resetLoading();

    if (getAllAttachments(original).length > 0) {
      this.context.executeAction(ShowToast, {
        type: ToastType.INFO,
        message: 'Attachments from the original answer were not included. You can re-add them to this copy.',
      });
    }
  }

  onFetchError(errDto) {
    this.context.stores.snippetComposition.resetLoading();
    handleCommonErrors(this.context, errDto);
    this.context.executeAction(ShowToast, {
      type: ToastType.ERROR,
      message: 'Could not clone the answer.',
    });
  }

  cloneContentWithoutAttachments(content) {
    if (!content) {
      return SnippetContent.create();
    }
    return SnippetContent.create({
      bodyHtml: stripInlineImages(content.bodyHtml || ''),
      internal: content.internal || false,
      name: content.name || '',
      subject: content.subject || '',
    });
  }
}

function stripInlineImages(html) {
  return html.replace(/<img\s[^>]*data-attachment-id[^>]*\/?>/gi, '');
}
